// @flow
import { fetchBidderDataIfNeeded, getAuthToken } from '../../../redux/modules/user';
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchWonItemsIfNeeded } from '../../../redux/modules/wonItems';
import { parseQueryParams } from '../../../utils/queryParams';

export const MAX_TODAY_AUCTIONS = 150; // remove this if our business really picks up...

export default ({ location, store }: DataLoaderParams) => {
    const { dispatch, getState } = store;
    const authToken = getAuthToken(getState());
    return Promise.all([dispatch(fetchBidderDataIfNeeded(authToken, true))]).then(() => {
        // need to force a bidder data fetch to ensure we get it back first
        const query: any = parseQueryParams(location.search);
        let page = 1;
        let pageSize = 10;
        ({ page, pageSize } = query);

        return Promise.all([dispatch(fetchWonItemsIfNeeded({ page, pageSize }))]);
    });
};
